import useSWR from 'swr';

export function useIsUnderMaintenance() {
  const { data: isUnderMaintenance } = useSWR(
    '/api/info/condition',
    (key: string) =>
      fetch(`${process.env.NEXT_PUBLIC_DOMAIN}${key}`)
        .then((r) => r.json())
        .then(({ status }) => status === 1)
  );
  return isUnderMaintenance;
}
